export default {"src":"/_next/static/media/raised-beds-vegetable-garden.5b145d0d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};